<template>
  <div class="privacy-page">
    <AboutHeader />

    <div class="tabs">
      <ul>
        <li :class="{ 'active': selectedTab === 'terms' }" @click="changeTab('terms');">Terms of Service</li>
        <li :class="{ 'active': selectedTab === 'privacy' }" @click="changeTab('privacy');">Privacy Policy</li>
      </ul>
    </div>

    <content-output key="privacy" type="privacy" v-show="selectedTab === 'privacy'" />
    <content-output key="terms" type="terms" v-show="selectedTab === 'terms'" />

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/Footer.vue';
import AboutHeader from '@/components/header/AboutHeader.vue';
import ContentOutput from '@/components/content_editor/ContentOutput.vue';

export default {
  name: 'Documents',

  props: {
    type: {
      type: String,
      default: 'terms'
    }
  },

  mounted() {
    this.selectedTab = this.type;
  },

  data() {
    return {
      selectedTab: 'terms',
    };
  },

  components: {
    Footer,
    ContentOutput,
    AboutHeader,
  },

  methods: {
    changeTab(tab) {
      if (this.selectedTab !== tab) {
        this.selectedTab = tab;
      }
    },

    toggleSmallMenu() {
      this.showSmallMenu = !this.showSmallMenu;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/css/variables";

.tabs {
  align-content: center;
  display: flex;
  justify-content: center;

  ul {
    list-style: none;
    padding: 0;

    li {
      padding: 20px;
      padding-bottom: 3px;
      display: inline-block;
      border-bottom: 2px solid $sec5;
      color: $sec5;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: bold;
      user-select: none;
      cursor: pointer;
    }

    .active {
      color: $blue;
      border-color: $blue;
    }
  }
}

.privacy-page {
  background: #F4F7FA;
}

</style>
